import React, { useEffect, useState } from 'react'
import config from 'src/config/config';
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { theme } from 'styled-tools';
import Intl from 'src/components/common/Intl';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';
import AppBenefits from 'src/components/appBenefits';
import DownldAndInstallStepsContent from 'src/components/appDownldAndInstallSteps';

//Images
import { FomoStep1Icon } from '../../components/icon/Step1Icon';
import { FomoStep2Icon } from '../../components/icon/Step2Icon';
import { FunStep3Icon } from '../../components/icon/Step3Icon';
import { FomoStep4Icon } from '../../components/icon/Step4Icon';
import { FomoStep5Icon } from '../../components/icon/Step5Icon';
import { FomoStep6Icon } from '../../components/icon/Step6Icon';
import { SRTM } from 'src/util/sportradarEvent';
import { AccordionOpenIconFun, AccordionCloseIconFun } from 'src/components/icon/AccordionIcon';
import AndroidIconFun from 'src/components/icon/AndroidIconFun';

function FunAppDownload(props) {
    const { app: {
        brandId
    }, theme } = props;

    const [apkUrl, setApkUrl] = useState('')
    const [accordionItem, setAccordionItem] = useState(null);

    const downloadAndInsatallData = [
        {
            id: 1,
            imgsrc: theme.image.StepOneMobImgOne,
            icon: theme.image.BetdailyAppDownloadStepOne,
            title: <span><Intl langKey="FunAppDwnld@ClickOnMenu" /><span className='customColor'><Intl langKey="FunAppDwnld@Menu" /></span><Intl langKey="FunAppDwnld@Options" /></span>,
            desc: <Intl langKey="YoloAppDwnld@ClickTheMenu" />
        },
        {
            id: 2,
            imgsrc: theme.image.StepTwoMobImg,
            icon: theme.image.BetdailyAppDownloadStepTwo,
            title: <span><Intl langKey="FunAppDwnld@Download" /><span className='customColor'><Intl langKey="FunAppDwnld@TheApp" /></span></span>,
            desc: <Intl langKey="YoloAppDwnld@ClickTheDownldAndroid" />
        },
        {
            id: 3,
            imgsrc: theme.image.StepThreeMobImg,
            icon: theme.image.BetdailyAppDownloadStepThree,
            title: <span><Intl langKey="FunAppDwnld@WaitForFile" /><span className='customColor'><Intl langKey="FunAppDwnld@ToDownload" /></span></span>,
            desc: <Intl langKey="YoloAppDwnld@OnceTheProcessIs" />
        },
        {
            id: 4,
            imgsrc: theme.image.StepFourthMobImg,
            icon: theme.image.BetdailyAppDownloadStepFour,
            title: <span><Intl langKey="FunAppDwnld@InstallTheFunApp" /><span className='customColor'><Intl langKey="FunAppDwnld@SmartPhoneFun" /></span></span>,
            desc: <Intl langKey="YoloAppDwnld@WaitForTheInsatalationprocess" />
        }
    ]

    const appBenefitData = [
        {
            id: 1,
            icon: <FomoStep1Icon />,
            titleNumber: "01",
            desc: <Intl langKey="FunAppDwnld@BenefitsStep1" />,
        },
        {
            id: 2,
            icon: <FomoStep2Icon />,
            titleNumber: "02",
            desc: <Intl langKey="FunAppDwnld@BenefitsStep2" />,
        },
        {
            id: 3,
            icon: <FunStep3Icon />,
            titleNumber: "03",
            desc: <Intl langKey="FunAppDwnld@BenefitsStep3" />,
        },
        {
            id: 4,
            icon: <FomoStep4Icon />,
            titleNumber: "04",
            desc: <Intl langKey="FunAppDwnld@BenefitsStep4" />,
        },
        {
            id: 5,
            icon: <FomoStep6Icon />,
            titleNumber: "05",
            desc: <Intl langKey="FunAppDwnld@BenefitsStep5" />,
        },
        {
            id: 6,
            icon: <FomoStep5Icon />,
            titleNumber: "06",
            desc: <Intl langKey="FunAppDwnld@BenefitsStep6" />,
        }
    ]

    const faqData = [
        {
            id: 1,
            titleNumber: "1",
            question: <Intl langKey="FunAppDwnld@FAQquestionOne" />,
            answer: <Intl langKey="FunAppDwnld@FAQanswerOne" />
        },
        {
            id: 2,
            titleNumber: "2",
            question: <Intl langKey="FunAppDwnld@FAQquestionTwo" />,
            answer: <Intl langKey="FunAppDwnld@FAQanswerTwo" />
        },
        {
            id: 3,
            titleNumber: "3",
            question: <Intl langKey="FunAppDwnld@FAQquestionThree" />,
            answer: <Intl langKey="FunAppDwnld@FAQanswerThree" />
        }
    ]

    useEffect(() => {
        SRTM.init(brandId)
    }, [])

    const toggleAccordion = (id: any) => {
        if (accordionItem === id) {
            return setAccordionItem(null);
        }
        setAccordionItem(id);
    }


    useEffect(() => {
        switch (brandId) {
            case 46:
                setApkUrl("https://getclub.fun88appgames.com/Fun88club.apk");
                break;
            case 47:
                setApkUrl("https://download.fun88appgames.com/Fun88.apk");
                break;
            default:
                setApkUrl("https://download.fun88appgames.com/Fun88.apk");
        }
    }, [brandId])

    const brandApp = (brandId === 46 || brandId === 47) ? 'Fun88 app' : '';

    return (
        <>
            <MainWrapper>
                <BannerSection>
                    <BanerLeftContent>
                        <span className='customColor'><Intl langKey="FunAppDwnld@BrandName" /></span> <Intl langKey="FunApp@Online" /><br></br><Intl langKey="FunApp@Betting" />
                    </BanerLeftContent>
                    <AnimateImg className="AnimateBD">
                        <AnimateImgSecond>
                            <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.AnimationImgSecond}`} effect="none" placeholder={<PlaceholderImage />} alt={brandApp} />
                        </AnimateImgSecond>
                        <AnimateImgThired>
                            <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.AnimationImgThired}`} effect="none" placeholder={<PlaceholderImage />} alt={brandApp} />
                        </AnimateImgThired>
                    </AnimateImg>
                    <BanerRightContent>
                        <FlexWrap><Intl langKey="FunAppDwnld@BettingApk" /></FlexWrap>
                        <SmallText><Intl langKey="FunAppDwnld@TheFunAppIsAvailable" /></SmallText>

                        <DownloadBtn href={apkUrl}>
                            <AndroidIconFun />
                            <Intl langKey="YoloAppDwnld@Download" />
                        </DownloadBtn>
                    </BanerRightContent>
                </BannerSection>

                <ScreenShotSection>
                    <TextCenterWrap>
                        <FlexWrap><Intl langKey="FunAppDwnld@App" /><span className='customColor'><Intl langKey="FunAppDwnld@Pages" /> </span></FlexWrap>
                        <SmallText><Intl langKey="FunAppDwnld@ScreenshotTextOne" /></SmallText>
                        <SmallText className='AppText'><Intl langKey="FunAppDwnld@ScreenshotTextTwo" /></SmallText>
                    </TextCenterWrap>
                    <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.AppScreenshotsImg}`} effect="none" placeholder={<PlaceholderImage />} alt={brandApp} />
                </ScreenShotSection>

                <ScanTheQRSection>
                    <ScanTheQRWrapper>
                        <BlockContent>
                            <span className='customColor'><Intl langKey="YoloAppDwnld@ScanTheQr" /></span>
                            <p><Intl langKey="YoloAppDwnld@AndDownloadTheApp" /></p>
                            <DownloadBtn href={apkUrl}>
                                <AndroidIconFun />
                                <Intl langKey="YoloAppDwnld@Download" />
                            </DownloadBtn>
                        </BlockContent>
                        <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.AppQrCode}`} effect="none" placeholder={<PlaceholderImage />} alt={brandApp} />
                    </ScanTheQRWrapper>
                </ScanTheQRSection>

                <AppBenefitsWrapper>
                    <TextLeftWrap>
                        <span><Intl langKey="FunAppDwnld@AppFeatures" /><span className='customColor'><Intl langKey="FunAppDwnld@BrandNameFeature" /></span></span>
                        <Intl langKey="FunAppDwnld@AppOnlineApp" />
                        <SmallText><Intl langKey="FunAppDwnld@KeyFeatureText" /></SmallText>
                    </TextLeftWrap>
                    <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.MobileUserImg}`} effect="none" placeholder={<PlaceholderImage />} />
                </AppBenefitsWrapper>

                <AppBenefitsSteps>
                    {appBenefitData.map((appbenefit) => (
                        <AppBenefits
                            key={appbenefit.id}
                            id={appbenefit.id}
                            icon={appbenefit.icon}
                            titleNumber={appbenefit.titleNumber}
                            desc={appbenefit.desc}
                        />
                    ))}
                </AppBenefitsSteps>

                <AppSattaOnline>
                    <TextCenterWrap>
                        <FlexWrap className='twoRow'>
                            <h4><Intl langKey="FunAppDwnld@SattaAppwhy" /><span className='customColor'><Intl langKey="FunAppDwnld@BrandNameFeature" /></span><Intl langKey="FunAppDwnld@SattaApp" /></h4>
                            <h4><Intl langKey="FunAppDwnld@SattaAppIndia" /></h4>
                        </FlexWrap>
                        <SmallText><Intl langKey="FunAppDwnld@SattaAppText" /></SmallText>
                    </TextCenterWrap>
                    <AppSattaWrapper>
                        <BorderWrapper>
                            <BonusContent>
                                <OnlineTitle>
                                    <h1><Intl langKey="FunAppDwnld@CasinoHeadTextOne" /></h1>
                                    <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.AppDownloadONlineImgOneFomo}`} effect="none" placeholder={<PlaceholderImage />} />
                                </OnlineTitle>
                                <BonusBody><Intl langKey="FunAppDwnld@CasinoBodyTextOne" /></BonusBody>
                            </BonusContent>
                            <BonusContent>
                                <OnlineTitle>
                                    <h1><Intl langKey="FunAppDwnld@CasinoHeadTextTwo" /></h1>
                                    <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.AppDownloadONlineImgTwoFomo}`} effect="none" placeholder={<PlaceholderImage />} />
                                </OnlineTitle>
                                <BonusBody><Intl langKey="FunAppDwnld@CasinoBodyTextTwo" /></BonusBody>
                            </BonusContent>
                            <BonusContent>
                                <OnlineTitle>
                                    <h1><Intl langKey="FunAppDwnld@CasinoHeadTextThree" /></h1>
                                    <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.AppDownloadONlineImgThreeFomo}`} effect="none" placeholder={<PlaceholderImage />} className="lastImg" />
                                </OnlineTitle>
                                <BonusBody><Intl langKey="FunAppDwnld@CasinoBodyTextThree" /></BonusBody>
                            </BonusContent>
                        </BorderWrapper>
                        <FlexWrap className='twoRow'>
                            <SmallText><Intl langKey="FunAppDwnld@SattaTextOne" /></SmallText>
                            <SmallText><Intl langKey="FunAppDwnld@SattaTextTwo" /></SmallText>
                        </FlexWrap>
                    </AppSattaWrapper>
                </AppSattaOnline>
                <DownAndInstall>
                    <TextCenterWrap>
                        <FlexWrap className='twoRow'>
                            <h2><Intl langKey="FunAppDwnld@HowTo" /><span className='customColor'><Intl langKey="FunAppDwnld@BrandNameFeature" /></span><Intl langKey="FunAppDwnld@ApkFor" /></h2>
                            <h2><Intl langKey="FunAppDwnld@Android" /></h2>
                        </FlexWrap>
                        <SmallText><Intl langKey="FunAppDwnld@TechnicallyFunApkOne" /></SmallText>
                        <SmallText className='textAlignCenter'><Intl langKey="FunAppDwnld@TechnicallyFunApkTwo" /></SmallText>
                    </TextCenterWrap>
                    <DownStepsWrapper>
                        <DownSteps>
                            <h1><Intl langKey="FunAppDwnld@NumberOne" /></h1>
                            <p><Intl langKey="FunAppDwnld@NumberOneText" /></p>
                        </DownSteps>
                        <DownSteps>
                            <h1><Intl langKey="FunAppDwnld@NumberTwo" /></h1>
                            <p><Intl langKey="FunAppDwnld@NumberTwoText" /></p>
                        </DownSteps>
                    </DownStepsWrapper>
                </DownAndInstall>
                <DownldAndInstallStepsWrapper>
                    {downloadAndInsatallData.map((dwnldInstall) => (
                        <DownldAndInstallStepsContent
                            key={dwnldInstall.id}
                            id={dwnldInstall.id}
                            imgsrc={dwnldInstall.imgsrc}
                            icon={dwnldInstall.icon}
                            title={dwnldInstall.title}
                            desc={dwnldInstall.desc}
                            apkUrl={apkUrl}
                        />
                    ))}
                </DownldAndInstallStepsWrapper>
                <DownloadEnd>
                    <TextCenterWrap>
                        <SmallText><Intl langKey="FunAppDwnld@DownloadTextOne" /></SmallText>
                        <SmallText className='textAlignCenter'><Intl langKey="FunAppDwnld@DownloadTextTwo" /></SmallText>
                    </TextCenterWrap>
                    <SignUpWrapper>
                        <AppSingnUp>
                            <h1>
                                <span className='customSignUp'><Intl langKey="FunAppDwnld@BrandNameFeature" /></span>
                                <Intl langKey="FunAppDwnld@SignUp" />
                            </h1>
                            <p><Intl langKey="FunAppDwnld@SignUpTextOne" /></p>
                        </AppSingnUp>
                        <AppSingnUp>
                            <h1><Intl langKey="FunAppDwnld@DepositText" /><span className='customSignUp'><Intl langKey="FunAppDwnld@BrandNameFeature" /></span></h1>
                            <p><Intl langKey="FunAppDwnld@SignUpTextTwo" /></p>
                        </AppSingnUp>
                    </SignUpWrapper>
                </DownloadEnd>
                <DownAndInstall>
                    <TextCenterWrap>
                        <FlexWrap className='twoRow'>
                            <h4><Intl langKey="FunAppDwnld@Bonus&Promo" /></h4>
                            <h4><Intl langKey="FunAppDwnld@BonusOn" /><span className='customColor'><Intl langKey="FunAppDwnld@BrandNameFeature" /></span></h4>
                        </FlexWrap>
                        <FlexWrap className='twoRow'>
                            <SmallText><Intl langKey="FunAppDwnld@PromotionTextOne" /></SmallText>
                            <SmallText><Intl langKey="FunAppDwnld@PromotionTextTwo" /></SmallText>
                        </FlexWrap>
                    </TextCenterWrap>
                    <AppSattaWrapper className='BonusContainer'>
                        <BorderWrapper>
                            <BonusContent>
                                <BonusTitle>
                                    <h3><Intl langKey="FunAppDwnld@BonusContentTitleOne" /></h3>
                                    <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.AppDownBonusImgOneFomo}`} effect="none" placeholder={<PlaceholderImage />} />
                                </BonusTitle>
                                <BonusBody><Intl langKey="FunAppDwnld@BonusContentBodyOne" /></BonusBody>
                            </BonusContent>
                            <BonusContent>
                                <BonusTitle>
                                    <h3><Intl langKey="FunAppDwnld@BonusContentTitleTwo" /></h3>
                                    <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.AppDownBonusImgTwoFomo}`} effect="none" placeholder={<PlaceholderImage />} />
                                </BonusTitle>
                                <BonusBody><Intl langKey="FunAppDwnld@BonusContentBodyTwo" /></BonusBody>
                            </BonusContent>
                            <BonusContent>
                                <BonusTitle>
                                    <h3><Intl langKey="FunAppDwnld@BonusContentTitleThree" /></h3>
                                    <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.AppDownBonusImgThreeFomo}`} effect="none" placeholder={<PlaceholderImage />} className="lastImg" />
                                </BonusTitle>
                                <BonusBody><Intl langKey="FunAppDwnld@BonusContentBodyThree" /></BonusBody>
                            </BonusContent>
                        </BorderWrapper>
                        <FlexWrap className='twoRow'>
                            <SmallText><Intl langKey="FunAppDwnld@PromotionTextThree" /></SmallText>
                            <SmallText><Intl langKey="FunAppDwnld@PromotionTextFour" /></SmallText>
                        </FlexWrap>
                    </AppSattaWrapper>
                </DownAndInstall>
                <DownAndInstall>
                    <TextCenterWrap>
                        <FlexWrap className='twoRow'>
                            <h4><span className='customColor'><Intl langKey="FunAppDwnld@BrandNameFeature" /></span><Intl langKey="FunAppDwnld@CasinoApp" /></h4>
                        </FlexWrap>
                        <FlexWrap className='twoRow'>
                            <SmallText><p className='Casinotext'><Intl langKey="FunAppDwnld@CasinoLineTextOne" /></p></SmallText>
                        </FlexWrap>
                    </TextCenterWrap>
                    <AppSattaWrapper className='CasinoContainer'>
                        <CasinoWrapper>
                            <BonusContent>
                                <CasinoTitle>
                                    <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.AppDownloadCasinoImgOneFomo}`} effect="none" placeholder={<PlaceholderImage />} />
                                </CasinoTitle>
                                <CasinoBody><p><Intl langKey="FunAppDwnld@OnlineTextOne" /></p></CasinoBody>
                            </BonusContent>
                            <BonusContent>
                                <CasinoTitle>
                                    <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.AppDownloadCasinoImgTwoFomo}`} effect="none" placeholder={<PlaceholderImage />} />
                                </CasinoTitle>
                                <CasinoBody><p><Intl langKey="FunAppDwnld@OnlineTextTwo" /></p></CasinoBody>
                            </BonusContent>
                            <BonusContent>
                                <CasinoTitle>
                                    <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.AppDownloadCasinoImgThreeFomo}`} effect="none" placeholder={<PlaceholderImage />} className="lastImg" />
                                </CasinoTitle>
                                <CasinoBody><p><Intl langKey="FunAppDwnld@OnlineTextThree" /></p></CasinoBody>
                            </BonusContent>
                            <BonusContent>
                                <CasinoTitle>
                                    <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.AppDownloadCasinoImgFourFomo}`} effect="none" placeholder={<PlaceholderImage />} className="lastSecondImg" />
                                </CasinoTitle>
                                <CasinoBody><p><Intl langKey="FunAppDwnld@OnlineTextFour" /></p></CasinoBody>
                            </BonusContent>
                        </CasinoWrapper>
                        <FlexWrap className='twoRow'>
                            <SmallText><Intl langKey="FunAppDwnld@CasinoLineTextFour" /></SmallText>
                            <SmallText><Intl langKey="FunAppDwnld@CasinoLineTextFive" /></SmallText>
                        </FlexWrap>
                    </AppSattaWrapper>
                </DownAndInstall>
                <DownAndInstall>
                    <TextCenterWrap>
                        <FlexWrap className='twoRow'>
                            <h4><Intl langKey="FunAppDwnld@SportsBet" /><span className='customColor'><Intl langKey="FunAppDwnld@BrandNameFeature" /></span></h4>
                            <h4><Intl langKey="FunAppDwnld@BettingApp" /></h4>
                        </FlexWrap>
                    </TextCenterWrap>
                    <SportsWrap>
                        <p><Intl langKey="FunAppDwnld@SportsTextOne" /></p>
                        <p><Intl langKey="FunAppDwnld@SportsTextTwo" /></p>
                        <p><Intl langKey="FunAppDwnld@SportsTextThree" /></p>
                        <p><Intl langKey="FunAppDwnld@SportsTextFour" /></p>
                    </SportsWrap>
                </DownAndInstall>

                <DownAndInstall>
                    <TextCenterWrap>
                        <FlexWrap className='twoRow'>
                            <h4><Intl langKey="FunAppDwnld@BettingHeading" /></h4>
                        </FlexWrap>
                    </TextCenterWrap>
                    <SportsWrap>
                        <p><Intl langKey="FunAppDwnld@BettingTextOne" /></p>
                    </SportsWrap>
                    <FAQWrapper>
                        <FaqTitle>
                            <h1><Intl langKey="FunAppDwnld@FAQHeading" /></h1>
                        </FaqTitle>
                        <AccordionContainer>
                            {
                                faqData.map((item, id) => (
                                    <>
                                        <AccordionWrapper onClick={() => toggleAccordion(id)} key={id}>
                                            <AccordianTitle>
                                                <h3>{item.titleNumber}. {item.question}</h3>
                                                <span>{accordionItem === id ? <AccordionCloseIconFun /> : <AccordionOpenIconFun />}</span>
                                            </AccordianTitle>
                                            <AccordianDisc>
                                                <p className={accordionItem === id ? 'active' : 'inActive'}>{item.answer}</p>
                                            </AccordianDisc>
                                        </AccordionWrapper>
                                        <UnderLine className="lastRow"></UnderLine>
                                    </>
                                ))
                            }
                        </AccordionContainer>
                    </FAQWrapper>
                </DownAndInstall>
            </MainWrapper>
        </>
    )
}

export default withTheme(withAppContext(FunAppDownload))

//Styled Components
const DownldAndInstallStepsWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8rem;
    padding-bottom: 100px;
`;

const DownAndInstall = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2rem;
    padding: 4rem 0;
    padding: 3rem;
    margin: 0 0;

    .BonusContainer {
        padding-bottom: 1rem;
    }

    .CasinoContainer {
        padding-bottom: 1rem;
    }
`;

const AppBenefitsSteps = styled.div`
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 3rem 2rem;
    padding: 4rem 0;
`;

const AppBenefitsWrapper = styled.div`
    width: 80%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;

    img {
        /* max-width: 100%; */
        animation: myAnim 3s ease 0s infinite alternate forwards;
        width: 100%;

        @keyframes myAnim {
            0% {
                transform: scale(0.7);
            }

            100% {
                transform: scale(0.9);
            }
        }
    }
`;

const BlockContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    .customColor {
        font-size: 20px;
        font-weight: 700;
    }

    p {
        width: 190px;
        margin: 20px 0;
        margin-top: 5px;
        font-size: 18px;
        color: ${theme('palette.appDownloadPageSmallText')};
    }
`;

const ScanTheQRWrapper = styled.div`
    display: flex;
    align-items: center;
    background: ${theme('palette.appDownloadPageScanTheQRWrapperBg')};
    border: ${theme('palette.appDownloadPageScanTheQRWrapperBorder')};
    border-radius: 23.809px;
    padding: 3rem;
    gap: 2rem;

    img {
        width: 220px;
    }
`;

const ScanTheQRSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 4rem;
`;

export const TextLeftWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 5px;
    font-size: 40px;
    font-family: 'Inter-Bold';
    color: ${theme('palette.appDownloadPageSmallText')};
`;

const TextCenterWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-family: 'Inter-Bold';

    .AppText {
        margin-top: -10px;
    }
`;

const ScreenShotSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 4rem 0;

    img {
        width: 80%;
        margin: 0 auto;
        display: block;
    }
`;

const AnimateImgThired = styled.div`
    width: 300px;
    position: absolute;
    right: 3rem;
    bottom: 6rem;
    z-index: 1;
    animation: myAnim 3s ease 0s infinite alternate forwards;

        @keyframes myAnim {
            0% {
                transform: scale(0.7);
            }

            100% {
                transform: scale(0.9);
            }
        }

    img {
        max-width: 100%;
    }
`;

export const AnimateImgSecond = styled.div`
    width: 345px;
    position: absolute;
    left: 7rem;
    top: 2rem;
    z-index: 1;
    animation: myAnim 3s ease 0s infinite alternate forwards;

    @keyframes myAnim {
        0% {
            transform: scale(0.7);
        }

        100% {
            transform: scale(0.9);
        }
    }

    img {
        max-width: 100%;
    }
`;

export const DownloadBtn = styled.a`
    width: 168px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-weight: 500;
    font-size: 14px;
    border-radius: 30px;
    padding: 8px 5px;
    color: ${theme('palette.appDownloadPageDownloadBtnColor')};
    background: ${theme('palette.appDownloadPageDownloadBtnBg')};
    margin: 0;
    border: none;
    box-shadow: none;
    cursor: pointer;

    :hover {
        background: ${theme('palette.appDownloadPageCustomColor')};
        color: ${theme('palette.appDownloadPageDownloadBtnColorHover')};

       svg {
        width: 20px;
            path {
               fill: ${theme('palette.appDownloadPageDownloadBtnColorHover')};
            } 
        }
    }

    svg {
        width: 20px;
    }
`;

const AnimateImg = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    svg {
        width: 700px;
        animation: myAnim 3s ease 0s infinite alternate forwards;

        @keyframes myAnim {
            0% {
                transform: scale(0.7);
            }

            100% {
                transform: scale(0.9);
            }
        }
    }
    
`;

export const SmallText = styled.div`
    font-weight: 500;
    font-family: 'Inter';
    font-size: 15px;
    color: ${theme('palette.appDownloadPageSmallText')};
    text-align: justify !important;


    &.textAlignCenter {
        text-align: center;
        margin-top: -10px;
    }

    .Casinotext {
        padding: 0 3rem;
        text-align: center;
    }
`;

export const FlexWrap = styled.div`
     display: flex;
     align-items: center;
     gap: 10px;
     color: ${theme('palette.appDownloadPageSmallText')};
     font-size: 40px;

     &.twoRow {
        flex-direction: column;
        gap: unset;
     }

    h2 {
        margin: 0;
        padding: 0;
        font-size: unset;
        text-transform: capitalize;
    }
    h4 {
        margin: 0;
        padding: 0;
        font-size: 35px;
        text-transform: capitalize;
    }
`;

const BanerRightContent = styled.div`
    width: 32%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 10px;
    color: ${theme('palette.appDownloadPageTextWhite')};
    font-family: 'Inter-Bold';
    position: absolute;
    right: 0;
    bottom: 1rem;

    @media only screen and (min-width: 1500px){
        width: 440px;
        right: 5%;
    }
`;

const BanerLeftContent = styled.div`
    color: ${theme('palette.appDownloadPageTextWhite')};
    text-align: right;
    font-family: 'Inter-Bold';
    font-size: 40px;
    position: absolute;
    left: 10%;
    top: 50px;
`;

const BannerSection = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    position: relative;
    padding-top: 1rem;
    background: url(${config.imageV3Host}/static/cashsite/${theme('image.AppDownloadBg')});
    background-position: top;
    background-size: contain;
    background-repeat: no-repeat;

    .AnimateBD {
        width: 700px;
        height: 700px;

        animation: myAnim 3s ease 0s infinite alternate forwards;

        @keyframes myAnim {
            0% {
                transform: scale(0.8);
            }

            100% {
                transform: scale(0.9);
            }
        }
    }
`;

const MainWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #EBEBEB;
    /* background: url(${config.imageV3Host}/static/cashsite/${theme('image.AppDownloadBg')}); */
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 0 4rem 1rem 4rem;

    .customColor {
        color: ${theme('palette.appDownloadPageCustomColor')};
    }
`;

const AppSattaOnline = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const AppSattaWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3rem;
    justify-content: center;
    align-items: center;
    padding: 5rem 0;
    text-align: center;
    z-index: 1;

    img {
        width: 65%;
    }
`;

const DownStepsWrapper = styled.div`
    display: flex;
    gap: 3rem;
    align-items: center;
    justify-content: center;
`;

const SignUpWrapper = styled.div`
    display: flex;
    gap: 3rem;
    align-items: stretch;
    justify-content: center;
    padding-top: 3rem;
    width: 90%;
`;

const DownSteps = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    border-radius: 20px;
    background: #FFF;
    padding: 2rem;

    h1 {
        font-size: 45px;
        font-style: normal;
        font-weight: 700;
        font-style: italic;
        line-height: normal;
        color: #2FB3FB;
        padding: 0%.5rem;
    }

    p {
        color: #4B4B4B;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 167.5%; /* 26.8px */
    }
`;

const DownloadEnd = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2rem;
    padding: 4rem 0;
    padding: 3rem;
    margin: 0 0;
`;

const AppSingnUp = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    gap: 1.3rem;
    border-radius: 23.809px;
    background: #FFF;
    backdrop-filter: blur(5.436415195465088px);
    padding: 2rem;

    h1 {
        color: #4B4B4B;
        font-size: 35px;
        font-style: normal;
        font-weight: 800;
        line-height: normal;
        background-clip: text;
        font-style: italic;
        margin: 0;
    }

    p {
        color: #4B4B4B;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 167.5%; /* 26.8px */
        margin: 0;
    }

    .customSignUp {
        color: #23AFFC;
        padding-right: 0.4rem;
    }
`;

const SportsWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    gap: 1rem;
    padding: 0 5rem;

    p {
        color: #4B4B4B;
    }
`;

const FAQWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    width: 90%;
    height: auto;
    padding: 3rem;
    position: relative;
    background: #FFF;
`;

const FaqTitle = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 0 2.5rem 0;
    width: 100%;

    h1 {
        color: #23AFFC;
        text-align: center;
        font-size: 45.466px;
        font-style: normal;
        font-weight: 700;
        line-height: 53.879px; /* 118.502% */
        text-transform: capitalize;
        margin: 0;
    }
`;



const AccordionContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
    justify-content: center;

    .lastRow:last-child {
        display: none;
    }
`;

const AccordionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const UnderLine = styled.div`
    height: 2px;
    width: 100%;
    background: #4B4B4B;
    align-self: center;
`;

const AccordianTitle = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;

    h3 {
        color: #4B4B4B;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 128.5%; /* 32.125px */
    }

    span {
        transition: transform 0.3s ease;
    }

    /* &:hover span {
        transform: rotate(180deg);
    } */
`;

const AccordianDisc = styled.div`
    display: flex;
    flex-direction: column;
    width: 85%;
    padding-left: 1.5rem;
    max-height: 500px;
    overflow: hidden;
    transition: max-height 0.3s ease;

    p {
        color: #4B4B4B;
        font-size: 15.163px;
        font-style: normal;
        font-weight: 500;
        line-height: 128.5%; /* 25.909px */
        transition: opacity 0.3s ease;
    }

    p.active {
        display: block;
        height: auto;
        opacity: 1;
    }

    p.inActive {
        display: none;
        opacity: 0;
    }
`;

const BorderWrapper = styled.div`
    display: flex;
    width: 70%;
    justify-content: center;
    gap: 2rem;
    align-items: stretch;
`;

const CasinoWrapper = styled(BorderWrapper)`
    width: 100%;
`;

const BonusContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    width: 100%;
    height: auto;
    padding: 1.5rem;
    position: relative;
    /* background: radial-gradient(71.58% 74.35% at 50.18% -11.77%, #112333 0%, #010406 100%); */
    background: #FFF;
`;

const BonusTitle = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    position: relative;

    h1 {
        font-size: 45px;
        font-style: normal;
        font-weight: 700;
        font-style: italic;
        padding-right: 0.5rem;
        line-height: normal;
        color: #2FB3FB;
    }

    h3 {
        color: #2FB3FB;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 100%; /* 20px */
        text-align: left;
        width: 45%;
    }

    img {
        position: absolute;
        width: 7rem;
        top: -3rem;
        right: 0;
    }

    .lastImg {
        position: absolute;
        width: 8rem;
        top: -4rem;
        right: -0.5rem;
    }
`;

const OnlineTitle = styled(BonusTitle)`
    img {
        position: absolute;
        width: 5rem;
        top: -3rem;
        right: 0;
    }

    .lastImg {
        position: absolute;
        width: 6.5rem;
        top: -4.5rem;
        right: 0;
    }
`;

const CasinoTitle = styled(BonusTitle)`
    height: 2rem;

    img {
        position: absolute;
        width: 6rem;
        top: -3rem;
        right: -1.5rem;
    }

    .lastImg {
        position: absolute;
        width: 5.5rem;
        top: -2.5rem;
        right: -1rem;
    }

    .lastSecondImg {
        position: absolute;
        width: 5rem;
        top: -2.5rem;
        right: -1rem;
    }
`;

const BonusBody = styled.div`
    display: flex;
    width: 100%;
    text-align: justify;
    color: #4B4B4B;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 120.3%; /* 19.248px */
`;

const CasinoBody = styled(BonusBody)`
    width: 100%;
    text-align: left;
    align-items: flex-start;

    p {
        width: 75%;
        margin: 0;
    }
`;